import { render, staticRenderFns } from "./ChecklistDetail.vue?vue&type=template&id=52214862&"
import script from "./ChecklistDetail.vue?vue&type=script&lang=js&"
export * from "./ChecklistDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports